import { render } from "./InvoiceIssue.vue?vue&type=template&id=632b02f8&scoped=true"
import script from "./InvoiceIssue.vue?vue&type=script&lang=js"
export * from "./InvoiceIssue.vue?vue&type=script&lang=js"

import "./InvoiceIssue.vue?vue&type=style&index=0&id=632b02f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632b02f8"]])

export default __exports__